<template>
  <!-- 有服列表：下拉选择；无 serverId / 匹配不到时不预填，由用户自选 -->
  <TempSelect
    v-if="!loadingGame && hasOptions"
    :formData="formData"
    :id="id"
    :customKey="serverCustomKey"
    :labelInfo="labelInfo"
    :required="labelInfo.required"
    :label="labelInfo.label"
    :placeholder="languages.smartOrderPleaseChoose + labelInfo.label"
  ></TempSelect>
  <!-- 服列表为空：允许用户手输 -->
  <TempInput
    v-else-if="!loadingGame"
    :formData="formData"
    :id="id"
    type="text"
    :labelInfo="labelInfo"
    :required="labelInfo.required"
    :label="labelInfo.label"
    :placeholder="languages.smartOrderPleaseInpt + labelInfo.label"
  ></TempInput>
</template>

<script>
import TempSelect from './TempSelect.vue';
import TempInput from './TempInput.vue';
import { mapActions } from 'vuex';
import workTemp from '@mixins/officialSupport/workTemp';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'TempServer',
  mixins: [workTemp],
  props: {
    gameId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      serverCustomKey: {
        defaultValue: undefined,
        options: []
      },
      loadingGame: true
    };
  },
  computed: {
    hasOptions() {
      return (
        Array.isArray(this.serverCustomKey.options) &&
        this.serverCustomKey.options.length > 0
      );
    }
  },
  async created() {
    await this.loadServerOptions(this.gameId);
  },
  methods: {
    ...mapActions(['getServerList']),
    // 获取服务器列表（与 worktemp 一致走 getServerList）
    async loadServerOptions(gameId) {
      try {
        this.loadingGame = true;
        const data = await this.getServerList(gameId);
        if (data && data?.length && data.length > 0) {
          this.serverCustomKey.options = data.map(item => {
            return {
              label: item.REAL_NAME,
              value: item.SID
            };
          });
          const serverId = globalConfig.getHrefParam('serverId') || '';
          if (serverId) {
            const serverItem = this.serverCustomKey.options.find(
              item => item.value == serverId
            );
            // 匹配到才预填；匹配不到保持空，由用户自行选择
            if (serverItem) {
              this.serverCustomKey.defaultValue = serverItem.value;
            }
          }
        } else {
          this.serverCustomKey.options = [];
          // 无列表走手输，避免 formData 仍是 worktemp 占位的 {}
          if (this.formData && this.id) {
            this.$set(this.formData, this.id, '');
          }
        }
        this.loadingGame = false;
        return Promise.resolve();
      } catch (error) {
        this.serverCustomKey.options = [];
        if (this.formData && this.id) {
          this.$set(this.formData, this.id, '');
        }
        this.loadingGame = false;
        return Promise.reject();
      }
    }
  },
  components: {
    TempSelect,
    TempInput
  }
};
</script>
